import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const dashBoardBaseUrl = `${Base_Url}/Dashboard`;

export const GetAdminDashboardCountModel = async (AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${dashBoardBaseUrl}/GetAdminDashboardCountModel?AdminKeyID=${AdminKeyID}`
  );
  return res;
};

export const GetAdminActivityLogList = async (params) => {
  const res = await postApiWithAuthorization(
    `${dashBoardBaseUrl}/GetAdminActivityLogList`,
    params
  );
  return res;
};
